import { Settings } from '@or-sdk/settings';
import { useAuthStore } from '@/stores/auth/auth';
import config from '../config';
export default new Settings({
    token: () => useAuthStore().reactiveToken,
    sdkUrl: `${config.SDK_API_URL}`,
});
